<template>
  <div>
    <div class="row text-left mt-4">
      <div class="col">
        <form @submit.prevent="saveBudget">
          <div
            class="px-2 py-2"
            style="border: 0.1rem solid gray; border-radius: 4px;"
          >
            <div class="form-group">
              <label for="title"><small>Title</small></label>
              <input
                class="form-control"
                id="title"
                v-model="reorderedBudgetTable.t"
                placeholder="Leave blank for no title"
              />
            </div>
            <div class="form-group">
              <label for="subtitle"><small>Subtitle</small></label>
              <input
                class="form-control"
                id="subtitle"
                v-model="reorderedBudgetTable.s"
                placeholder="Leave blank for no subtitle"
              />
            </div>
            <table class="table">
              <tbody id="budgetTable">
                <tr
                  v-for="(row, rowindex) in budgetTable.r"
                  :key="rowindex"
                  v-bind:class="{ 'header-row': row.h == true }"
                >
                  <i
                    v-if="rowindex != 0"
                    class="pointer material-icons text-danger mt-3"
                    v-on:click="removeRow(row)"
                  >
                    clear
                  </i>
                  <i v-else class="material-icons" style="visibility: hidden;"
                    >clear</i
                  >
                  <td
                    v-for="(col, index) in row.c"
                    :key="index"
                    v-bind:colspan="col.cs ? col.cs : 1"
                  >
                    <div v-if="col.i == 'd'" class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">$</span>
                      </div>
                      <input
                        class="form-control"
                        type="number"
                        v-model="col.v"
                      />
                    </div>
                    <div v-else>
                      <input
                        v-if="col.sum"
                        class="form-control"
                        disabled
                        v-bind:value="
                          $updateBudgetCol(
                            col,
                            row.c[index - 2].v * row.c[index - 1].v
                          )
                        "
                      />
                      <input
                        v-else-if="col.st"
                        class="form-control"
                        disabled
                        v-bind:value="
                          $updateBudgetCol(
                            col,
                            $getBudgetSectionTotal(
                              reorderedBudgetTable.r,
                              row.c[0].v
                            )
                          )
                        "
                      />
                      <input
                        v-else
                        class="form-control"
                        v-bind:type="$getBudgetColType(col.i)"
                        v-model="col.v"
                      />
                    </div>
                  </td>
                  <i
                    v-if="row.h != true"
                    class="pointer handle material-icons mt-3"
                    >reorder</i
                  >
                  <i v-else class="material-icons" style="visibility: hidden;"
                    >reorder</i
                  >
                </tr>
                <tr v-if="budgetTable.r.length > 0">
                  <i class="material-icons" style="visibility: hidden;"
                    >clear</i
                  >
                  <td>
                    <button
                      class="btn btn-link"
                      type="button"
                      v-on:click="addDataRow"
                    >
                      Add Row
                    </button>
                  </td>
                  <td>
                    <button
                      class="btn btn-link"
                      type="button"
                      v-on:click="addTotalRow"
                    >
                      Add Total Row
                    </button>
                  </td>
                  <td v-if="budgetTable.r[0].c.length > 2"></td>
                  <td v-if="budgetTable.r[0].c.length > 3"></td>
                  <i class="material-icons" style="visibility: hidden;"
                    >reorder</i
                  >
                </tr>
                <tr v-if="budgetTable.r.length > 0" class="header-row">
                  <i class="material-icons" style="visibility: hidden;"
                    >clear</i
                  >
                  <td v-bind:colspan="budgetTable.r[0].c.length - 1">Total</td>
                  <td>{{ $getBudgetTotal(budgetTable.r) }}</td>
                  <i class="material-icons" style="visibility: hidden;"
                    >reorder</i
                  >
                </tr>
              </tbody>
            </table>
          </div>
          <p class="text-secondary">
            {{ JSON.stringify(budgetTable).length }} / 8000 characters
          </p>

          <div class="text-right">
            <button type="submit" class="btn btn-primary">
              Save Budget
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Sortable from "sortablejs";

export default {
  name: "ApplicationBudgetEditing",
  components: {},
  props: {
    Budget: Object
  },
  data() {
    return {
      budgetTable: {
        t: "",
        s: "",
        r: []
      },
      reorderedBudgetTable: {
        t: "",
        s: "",
        r: []
      },
      justification: ""
    };
  },
  mounted() {
    if (this.Budget != null) {
      var rows = this.Budget.Budget;
      if (typeof rows == "string") {
        rows = JSON.parse(this.Budget.Budget);
      }
      this.reorderedBudgetTable.t = this.Budget.Title;
      this.reorderedBudgetTable.s = this.Budget.Subtitle;
      rows.forEach(row => {
        this.budgetTable.r.push(row);
        this.reorderedBudgetTable.r.push(row);
      });
    }
    $(document).ready(function() {
      $('[data-toggle="popover"]').popover();
    });
    var view = this;
    var el = document.getElementById("budgetTable");
    Sortable.create(el, {
      handle: ".handle",
      animation: 200,
      onEnd: function(e) {
        if (e.oldIndex != e.newIndex) {
          view.updateRowOrder(e.oldIndex, e.newIndex);
        }
      }
    });
  },
  async beforeDestroy() {
    await this.saveBudget();
  },
  async deactivated() {
    await this.saveBudget();
  },
  methods: {
    async saveBudget() {
      if (this.$props.Budget.Grant_Application_Budget_Id != null) {
        await this.updateBudget();
      } else {
        await this.createBudget();
      }
    },
    async updateBudget() {
      var view = this;
      view.$store.commit("updateLoading", true);
      var budgetToUpdate = {
        Grant_Application_Budget_Id:
          view.$props.Budget.Grant_Application_Budget_Id,
        Title: view.reorderedBudgetTable.t,
        Subtitle: view.reorderedBudgetTable.s,
        Budget: view.reorderedBudgetTable.r,
        Justification: view.justification,
        Grant_Application_Id: view.$props.Budget.Grant_Application_Id
      };

      await view
        .$updateGrantApplicationBudget(budgetToUpdate)
        .then(updatedBudget => {
          view.$emit("updatedApplicationBudget", updatedBudget);
          view.$store.commit("updateLoading", false);
          view.$showSnackbar("Your budget has been saved.", false);
        });
    },
    async createBudget() {
      var view = this;
      view.$store.commit("updateLoading", true);
      var budgetToCreate = {
        Title: view.reorderedBudgetTable.t,
        Subtitle: view.reorderedBudgetTable.s,
        Budget: view.reorderedBudgetTable.r,
        Justification: view.justification,
        Grant_Application_Id: view.$props.Budget.Grant_Application_Id
      };
      await view
        .$createGrantApplicationBudget(budgetToCreate)
        .then(createdBudget => {
          view.$emit("addedApplicationBudget", createdBudget);
          view.$store.commit("updateLoading", false);
          view.$showSnackbar("Your budget has been saved.", false);
        });
    },
    async updateRowOrder(oldIndex, newIndex) {
      var movedRow = this.reorderedBudgetTable.r[oldIndex];
      if (oldIndex - newIndex > 0) {
        for (let index = oldIndex; index > newIndex; index--) {
          this.reorderedBudgetTable.r[index] = this.reorderedBudgetTable.r[
            index - 1
          ];
        }
      } else {
        for (let index = oldIndex; index < newIndex; index++) {
          this.reorderedBudgetTable.r[index] = this.reorderedBudgetTable.r[
            index + 1
          ];
        }
      }
      this.reorderedBudgetTable.r[newIndex] = movedRow;

      this.$forceUpdate();
    },
    addDataRow() {
      var newCols = JSON.parse(
        JSON.stringify(this.reorderedBudgetTable.r[1].c)
      );
      var newRow = {
        c: newCols,
        h: false
      };
      this.budgetTable.r.push(newRow);
      this.reorderedBudgetTable.r.push(newRow);
    },
    addTotalRow() {
      var newRow = {
        c: [
          {
            v: "Subtotal " + (this.budgetTable.r.filter(r => r.st).length + 1),
            cs: this.reorderedBudgetTable.r[1].c.length - 1
          },
          {
            v: 0,
            st: true
          }
        ],
        h: true,
        st: true
      };
      this.budgetTable.r.push(newRow);
      this.reorderedBudgetTable.r.push(newRow);
    },
    removeRow(row) {
      var budgetTableRowIndex = this.budgetTable.r.findIndex(r => r == row);
      this.budgetTable.r.splice(budgetTableRowIndex, 1);

      var reOrderedBudgetTableRowIndex = this.reorderedBudgetTable.r.findIndex(
        r => r == row
      );
      this.reorderedBudgetTable.r.splice(reOrderedBudgetTableRowIndex, 1);
    }
  }
};
</script>
